// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ugzgl","rootParamsCollapsed":"styles_rootParamsCollapsed__3Dt-1","rootPreviewFull":"styles_rootPreviewFull__20jb6","loader":"styles_loader__mDWur"};